import adapterRequest from '@remote/api/adapter'
import { safeJSONParse } from '@shared/utils'
import { store } from '@remote/store'
import { useEnvStore } from '@remote/store/env'
import {guid as uuidv4} from '@remote/api/adapter/helper'
import reporter, { IReportMessage } from './reporter'
import CONFIG from '../../../hezi.config'
export { v4 as uuidv4 } from 'uuid'

const APP_VERSION = 'web_pc_' + CONFIG.version

interface IReportParams {
  type: 'info' | 'error'
  traceId: string
  platform: 'pc' | 'h5' | 'an' | 'ios'
  biz: 'hezi'
  eventId: string
  timestamp: number
  userId?: number | string
  deviceId?: string
  /** 额外信息，JSON字符串 */
  extData?: string
}

const stdout: 'console' | 'remote' | 'both' = process.env.NODE_ENV === 'development' ? 'console' : 'remote'

function logs (_logger: string, ..._args: unknown[]) {
  console.log(`${_logger}:`, ..._args)
}

const traceId = Date.now().toString(36)

function report (options: IReportParams) {
  const { type = 'info', platform = 'pc', biz = 'hezi', traceId, timestamp = Date.now(), eventId = '', extData = '' } = options
  if (stdout !== 'remote') {
    const type = options.type === 'info' ? 'Info' : 'Error'
    logs(`[Reporter][${type}][${eventId}]`, stdout, safeJSONParse(extData))
    if (stdout === 'console') return
  }
  const envStore = useEnvStore()
  const topic = type === 'info' ? 'report_info' : 'report_error'
  const userId = options.userId || envStore.userID || store.state?.user?.userID || global.userId || '0'
  const deviceId = options.deviceId ||  store.state?.deviceInfoWatchData.target

  const reportData: IReportMessage = {
    topic,
    traceId,
    platform,
    biz,
    eventId,
    timestamp,
    userId: userId ? +userId : userId,
    deviceId,
    extData,
  }
  reporter.push(reportData)
}

function getCommonExtdata () {
  const guid = window.btoa(navigator.userAgent)
  const userInfo = store.state?.user
  const { userID: userid = '' } = userInfo || {}
  const device_id = store.state?.deviceInfoWatchData.target

  return {
    guid,
    appVersion: APP_VERSION,
    device_id,
    userid,
    // 时间上的traceId,
    traceId,
  }
}

export function logInfo (eventId: string, ext = {} as any) {
  const opts = {
    type: 'info',
    traceId: ext.traceId || uuidv4(),
    platform: 'pc',
    biz: 'hezi',
    timestamp: Date.now(),
  }
  const commonExtData = getCommonExtdata()
  const extData = { ...ext, ...commonExtData }
  const userId = commonExtData.userid
  const deviceId = commonExtData.device_id
  const params = { 
    ...opts,
    eventId,
    userId,
    deviceId,
    extData: JSON.stringify(extData),
  } as IReportParams

  return report(params)
}

export function logError (eventId: string, ext = {} as any) {
  const opts = {
    type: 'error',
    traceId: ext.traceId || uuidv4(),
    platform: 'pc',
    biz: 'hezi',
    timestamp: Date.now(),
  }
  const commonExtData = getCommonExtdata()
  const extData = { ...ext, ...commonExtData }
  const userId = commonExtData.userid
  const deviceId = commonExtData.device_id
  const params = { 
    ...opts,
    eventId,
    userId,
    deviceId,
    extData: JSON.stringify(extData),
  } as IReportParams

  return report(params)
}

export function logFactory (label: string, traceId = uuidv4()) {
  return function log (...args: unknown[]) {
    console.log(`[${label}]:`, ...args)
    logInfo(label, { traceId, args })
  }
}

export function reportSwitchDevice () {
  const url = 'https://api-hezi.xunlei.com/api/v1/device/switch_report'
  const commonExtData = getCommonExtdata()
  const userId = commonExtData.userid
  const deviceId = commonExtData.device_id
  const data = {
    platform: 'pc',
    appversion: APP_VERSION,
    userId,
    user_id: userId,
    device_id: deviceId,
  }
  adapterRequest(url, data, {method: 'POST'})
}

export function reportPlayVideo (fileId = '', playSeconds = 0, videoInfo = {}) {
  const url = '/drive/v1/events'
  const commonExtData = getCommonExtdata()
  const userId = commonExtData.userid
  const deviceId = commonExtData.device_id
  const data = {
    platform: 'pc',
    appversion: APP_VERSION,
    user_id: userId,
    space: deviceId,
    event: {
      type: 'TYPE_PLAY',
      file_id: fileId,
      params: {
        play_seconds: playSeconds.toFixed(),
        media_id: fileId,
      },
    },
    video_info: videoInfo,
  }
  return adapterRequest(url, data, {method: 'POST'})
}
